// src/app/redux/actions/etablissementsActions.js

// ===== TYPES =====
export const FETCH_ETABLISSEMENTS_REQUEST = "FETCH_ETABLISSEMENTS_REQUEST";
export const FETCH_ETABLISSEMENTS_SUCCESS = "FETCH_ETABLISSEMENTS_SUCCESS";
export const FETCH_ETABLISSEMENTS_FAIL = "FETCH_ETABLISSEMENTS_FAIL";

export const CREATE_ETABLISSEMENT_REQUEST = "CREATE_ETABLISSEMENT_REQUEST";
export const CREATE_ETABLISSEMENT_SUCCESS = "CREATE_ETABLISSEMENT_SUCCESS";
export const CREATE_ETABLISSEMENT_FAIL = "CREATE_ETABLISSEMENT_FAIL";

export const UPDATE_ETABLISSEMENT_REQUEST = "UPDATE_ETABLISSEMENT_REQUEST";
export const UPDATE_ETABLISSEMENT_SUCCESS = "UPDATE_ETABLISSEMENT_SUCCESS";
export const UPDATE_ETABLISSEMENT_FAIL = "UPDATE_ETABLISSEMENT_FAIL";

export const DELETE_ETABLISSEMENT_REQUEST = "DELETE_ETABLISSEMENT_REQUEST";
export const DELETE_ETABLISSEMENT_SUCCESS = "DELETE_ETABLISSEMENT_SUCCESS";
export const DELETE_ETABLISSEMENT_FAIL = "DELETE_ETABLISSEMENT_FAIL";

export const SET_ETABLISSEMENTS_LOADING = "SET_ETABLISSEMENTS_LOADING";

// ===== ACTION CREATORS =====
export const setEtablissementsLoading = (loading) => ({
    type: SET_ETABLISSEMENTS_LOADING,
    payload: loading,
});

export const fetchEtablissementsRequest = () => ({ type: FETCH_ETABLISSEMENTS_REQUEST });
export const fetchEtablissementsSuccess = (data) => ({ type: FETCH_ETABLISSEMENTS_SUCCESS, payload: data });
export const fetchEtablissementsFail = (error) => ({ type: FETCH_ETABLISSEMENTS_FAIL, payload: error });

export const createEtablissementRequest = (payload) => ({ type: CREATE_ETABLISSEMENT_REQUEST, payload });
export const createEtablissementSuccess = (data) => ({ type: CREATE_ETABLISSEMENT_SUCCESS, payload: data });
export const createEtablissementFail = (error) => ({ type: CREATE_ETABLISSEMENT_FAIL, payload: error });

export const updateEtablissementRequest = (id, payload) => ({
    type: UPDATE_ETABLISSEMENT_REQUEST,
    payload: { id, payload },
});
export const updateEtablissementSuccess = (data) => ({ type: UPDATE_ETABLISSEMENT_SUCCESS, payload: data });
export const updateEtablissementFail = (error) => ({ type: UPDATE_ETABLISSEMENT_FAIL, payload: error });

export const deleteEtablissementRequest = (id) => ({ type: DELETE_ETABLISSEMENT_REQUEST, payload: { id } });
export const deleteEtablissementSuccess = (id) => ({ type: DELETE_ETABLISSEMENT_SUCCESS, payload: id });
export const deleteEtablissementFail = (error) => ({ type: DELETE_ETABLISSEMENT_FAIL, payload: error });
